export default {
  "Autocomplete.all_number_selected": "모든 {number} 선택됨",
  "Autocomplete.all_number": "모두({number})",
  "Card.toggle_content": "콘텐츠 전환",
  "Chip.remove": "제거하다",
  "DatePicker.next": "다음",
  "DatePicker.previous": "이전의",
  "Pagination.first": "첫 번째",
  "Pagination.go_to_page_number": "페이지 {index}로 이동",
  "Pagination.go_to_page": "{label} 페이지로 이동",
  "Pagination.last": "마지막",
  "Pagination.next": "다음",
  "Pagination.previous": "이전의",
  "Table.actions": "테이블 작업",
  "Table.add_column": "열 추가",
  "Table.filter": "필터",
  "Table.hide": "숨다",
  "Table.more_actions": "더 많은 행동",
  "Table.move_left": "왼쪽으로 이동",
  "Table.move_right": "오른쪽으로 이동해라",
  "Table.not_specified": "명시되지 않은",
  "Table.pagination": "테이블 페이지 매김",
  "Table.per_page": "페이지 당",
  "Table.position_zero": "0/{total}",
  "Table.position": "{start}-{end}/{total}",
  "Table.search": "찾다",
  "Table.select_all": "모두 선택",
  "Table.select_row": "{row} 선택",
  "Table.sort_ascending": "오름차순 정렬",
  "Table.sort_descending": "내림차순 정렬",
  "TextInput.clear_labelled_input": "{label} 지우기",
  "Ui.clear_all": "모두 지우기",
  "Ui.close": "닫다",
  "Ui.loading": "로드 중",
  "Ui.no_results": "결과 없음",
  "Ui.number_selected": "{number} 선택됨",
  "Ui.remove": "제거하다",
  "Ui.select_all": "모두 선택",
  "Ui.show_more": "+ {count} 더보기"
}
